import React from "react";
import "./footer.scss";
import { CompanyInfo, QuickLink } from "../../constants/Footer";
import logo from "../../assets/UMSImage/LogoKit/UMS-Logo-Gradient.png";
import google from "../../assets/UMSImage/Hippa-GoogleReview_HipCompliant.png";

const Footer = () => {
  return (
    <>
      <section id="footer">
      <div className="footer-area mt-4">
            <div className="row">
              <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
                <h6 className="text-uppercase mb-4 font-weight-bold">
                  Quick Links
                </h6>
                {QuickLink?.map((item) => {
                  return (
                    <>
                      <p>
                        <a>{item?.title}</a>
                      </p>
                    </>
                  );
                })}
              </div>
              <hr className="w-100 clearfix d-md-none" />
              <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
                <h6 className="text-uppercase mb-4 font-weight-bold">
                  Company Info
                </h6>
                {CompanyInfo?.map((item) => {
                  return (
                    <>
                      <p>
                        <a>{item?.title}</a>
                      </p>
                    </>
                  );
                })}
              </div>
              <hr className="w-100 clearfix d-md-none" />
              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3 ">
                <h6 className="text-uppercase mb-4 font-weight-bold">
                  Contact us
                </h6>
                <div className="contact">
                  <a href="tel:+13026080876">(302) 608-0876</a>
                </div>
                <div className="contact">
                  <a href="tel:+18889083523">(888) 908-3523</a>
                </div>
                <div className="contact">
                  <a href="mailto:support@theums.us">support@theums.us</a>
                </div>
                <div className="contact">
                  <a href="">Your Account</a>
                </div>
              </div>
              <hr className="w-100 clearfix d-md-none" />
              <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                <img src={logo} alt="" />
              </div>
            </div>
            <hr className="my-3" />
            <div className="row d-flex align-items-center">
            <div className="col-md-4  text-center text-md-start">
            <div className="row extra-page">
                  <div className="col-3">
                    <a href="">Terms</a>
                  </div>
                  <div className="col-3">
                    <a href="">Privacy</a>
                  </div>
                  <div className="col-3">
                    <a href="">Cookies</a>
                  </div>
                  </div>
                
              </div>
              <div className="col-md-4  text-center text-md-start">
                <div className="p-3">
                  © {new Date().getFullYear()} The UMS | All Rights Reserved
                </div>
              </div>
              <div className="col-md-4 text-center text-md-end google">
                <img src={google} alt="" />
              </div>
            </div>
          </div>
      </section>
    </>
  );
};

export default Footer;
